import { ChangeEvent, useState } from "react";
import { AnyType } from "../interfaces";

type ChangeEventCallback = (e: ChangeEvent<HTMLInputElement|HTMLSelectElement|HTMLTextAreaElement>) => void;

interface FormOptions {
  onInputChange?: ChangeEventCallback;
}

interface FormReturn<T> {
  values: T;
  setValues: (values: T) => void;
  handleChange: ChangeEventCallback;
  reset: () => void;
}

export default function useForm<T extends Record<string, AnyType>>(initialValues: T, options?: FormOptions): FormReturn<T> {
  const [values, setValues] = useState(initialValues);
  const { onInputChange } = options ?? {};

  return {
    values,
    setValues,
    handleChange: (e: ChangeEvent<HTMLInputElement|HTMLSelectElement|HTMLTextAreaElement>) => {
      setValues({
        ...values,
        [e.target.name]: e.target.value,
      });

      if(typeof onInputChange === "function") {
        onInputChange(e);
      }

      /*const { name, value } = e.target;

      setValues(prevValues => ({
        ...prevValues,
        [name]: value
      }));*/
    },
    reset: () => setValues(initialValues),
  };
};
